/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/person'
export default icon
